module.exports = __webpack_public_path__ + "static/media/upload-image-icon.5ac4e9fa.svg";